<template>
  <div class="session-blocked-container">
    <div class="body d-flex flex-column">
      <div>
        <strong>{{ $t("message.session.sessionTabDisabled") }}</strong>
      </div>
      <div class="session-tab-opened-msg">
        {{ $t("message.session.sessionUniqueWarning") }}
      </div>
      <div>{{ $t("message.session.sessionTabOpened") }}</div>
      <div>{{ $t("message.session.sessionCloseTab") }}</div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.session-blocked-container {
  height: 100vh;
  padding: 50px;
  .body {
    height: 100%;
    display: flex;
    background-color: #a2c0e2;
    justify-content: center;
    align-items: center;
    font-size: 1.2rem;
    padding: 80px;
    text-align: center;
    border-radius: 50px;

    .session-tab-opened-msg {
      margin-top: 1.2rem;
      margin-bottom: 0.8rem;
    }
  }
}
</style>
